import React, { Component } from 'react';
import pauseIcon from '../../images/pause-button.png';

const url = 'http://gvm.itoperators.dk:5006/api/GVM/';

export default class Information extends Component {
  static propTypes = {

  };


  state = {
      GV1Alarm: [],
      GV2Alarm: [],
      GV3Alarm: [],
      percentage: [],
      GV1TestAlarm: 300,
      GV2TestAlarm: 900,
      GV3TestAlarm: 900,
    }

  componentDidMount() {
    this.fetchGeneratorData();
    this.timerID = setInterval(
      () => this.fetchGeneratorData(),
      5000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchGeneratorData = async () => {

    let GV1AlarmCall = await fetch(url + '1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'AlarmNo' }});
    let GV2AlarmCall = await fetch(url + '2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'AlarmNo' }});
    let GV3AlarmCall = await fetch(url + '3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'AlarmNo' }}); 
    let PercentageCall = await fetch(url + '1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'PercentageGVM' }}); 

     await Promise.all([GV1AlarmCall, GV2AlarmCall, GV3AlarmCall, PercentageCall])    
      .then(([res1, res2, res3, res4]) => Promise.all([res1.json(), res2.json(), res3.json(), res4.json()]))
      .then(([data1, data2, data3, data4]) => this.setState({
          GV1Alarm: data1,
          GV2Alarm: data2,
          GV3Alarm: data3,
          percentage: data4,
      }));
  }

  render() {

    // console.log(this.state.GV1Alarm.value);
    // console.log(this.state.GV2Alarm.value);
    // console.log(this.state.GV3Alarm.value);
     console.log(this.state.percentage.value + "%");

    let firstLine = "";
    let secondLine = "";
    let thirdLine = "";
    let fourthLine = "";

    // if(this.state.GV1TestAlarm !== 900 && this.state.GV2TestAlarm !== 900 && this.state.GV3TestAlarm !== 900) {
    //   if (this.state.GV1TestAlarm !== 0 && !isNaN(this.state.GV1TestAlarm)) {
    //     if(this.state.GV1TestAlarm === 300) {
    //       thirdLine += "Mølle 1";
    //     }                 
    //   }
    //   if(this.state.GV2TestAlarm !== 0 && !isNaN(this.state.GV2TestAlarm)) {
    //     if(this.state.GV2TestAlarm === 300) {
    //       if (this.state.GV1TestAlarm === 300 && this.state.GV3TestAlarm === 300) {
    //         thirdLine += ", 2";
    //       }
    //       else if (this.state.GV1TestAlarm === 300 && this.state.GV3TestAlarm !== 300) {
    //         thirdLine += "og 2";
    //       }
    //       else {
    //          thirdLine += "Mølle 2";
    //       }
    //     }          
    //   }
    //   if(this.state.GV3TestAlarm !== 0  && !isNaN(this.state.GV3TestAlarm)) {
    //     if(this.state.GV3TestAlarm === 300) {
    //       if (this.state.GV1TestAlarm === 300 || this.state.GV2TestAlarm === 300) {
    //         thirdLine += " og 3";
    //       }          
    //       else {             
    //         thirdLine += "Mølle 3";
    //       } 
    //     }                 
    //   }
    //   if(this.state.GV1TestAlarm === 300 || this.state.GV2TestAlarm === 300 || this.state.GV3TestAlarm === 300) {
    //     fourthLine += " er stoppet pga. service!";
    //   }                
    // }
    // else {
    //     if(this.state.GV1TestAlarm === 900) {
    //       thirdLine += "Mølle 1";
    //     }                       
    //     if(this.state.GV2TestAlarm === 900) {
    //       if (this.state.GV1TestAlarm === 900 && this.state.GV3TestAlarm === 900) {
    //         thirdLine += ", 2";
    //       }
    //       else if (this.state.GV1TestAlarm === 900 && this.state.GV3TestAlarm !== 900) {
    //         thirdLine += "og 2";
    //       }
    //       else {
    //          thirdLine += "Mølle 2";
    //       }
    //     }  
    //     if(this.state.GV3TestAlarm === 900) {
    //       if (this.state.GV1TestAlarm === 900 || this.state.GV2TestAlarm === 900) {
    //         thirdLine += " og 3";
    //       }          
    //       else {             
    //         thirdLine += "Mølle 3";
    //       } 
    //     } 
    //   if(this.state.GV1TestAlarm === 900 || this.state.GV2TestAlarm === 900 || this.state.GV3TestAlarm === 900) {
    //     thirdLine += "!";
    //     fourthLine = "Vi regulerer pga. overproduktion på nettet.";
    //   }            
    // } 


    firstLine += "Lige nu producerer Gårestrup Vindmøllepark";
    secondLine +=  this.state.percentage.value <= 0 ? 0 : Math.round(this.state.percentage.value)  + "% af byens strøm"; 
    
    
    if(this.state.GV1Alarm.value !== 309 && this.state.GV2Alarm.value !== 309 && this.state.GV3Alarm.value !== 309) {
      if (this.state.GV1Alarm.value !== 0 && !isNaN(this.state.GV1Alarm.value)) {
        if(this.state.GV1Alarm.value === 900) {
          thirdLine += "Mølle 1";
        }                 
      }
      if(this.state.GV2Alarm.value !== 0 && !isNaN(this.state.GV2Alarm.value)) {
        if(this.state.GV2Alarm.value === 900) {
          if (this.state.GV1Alarm.value === 900 && this.state.GV3Alarm.value === 900) {
            thirdLine += ", 2";
          }
          else if (this.state.GV1Alarm.value === 900 && this.state.GV3Alarm.value !== 900) {
            thirdLine += "og 2";
          }
          else {
             thirdLine += "Mølle 2";
          }
        }          
      }
      if(this.state.GV3Alarm.value !== 0  && !isNaN(this.state.GV3Alarm.value)) {
        if(this.state.GV3Alarm.value === 900) {
          if (this.state.GV1Alarm.value === 900 || this.state.GV2Alarm.value === 900) {
            thirdLine += " og 3";
          }          
          else {             
            thirdLine += "Mølle 3";
          } 
        }                 
      }
      if(this.state.GV1Alarm.value === 900 || this.state.GV2Alarm.value === 900 || this.state.GV3Alarm.value === 900) {
        fourthLine += " er stoppet pga. service!";
      }                
    }
    else {
        if(this.state.GV1Alarm.value === 309) {
          thirdLine += "Mølle 1";
        }                       
        if(this.state.GV2Alarm.value === 309) {
          if (this.state.GV1Alarm.value === 309 && this.state.GV3Alarm.value === 309) {
            thirdLine += ", 2";
          }
          else if (this.state.GV1Alarm.value === 309 && this.state.GV3Alarm.value !== 309) {
            thirdLine += "og 2";
          }
          else {
             thirdLine += "Mølle 2";
          }
        }  
        if(this.state.GV3Alarm.value === 309) {
          if (this.state.GV1Alarm.value === 309 || this.state.GV2Alarm.value === 309) {
            thirdLine += " og 3";
          }          
          else {             
            thirdLine += "Mølle 3";
          } 
        } 
      if(this.state.GV1Alarm.value === 309 || this.state.GV2Alarm.value === 309 || this.state.GV3Alarm.value === 309) {
        thirdLine += "!";
        fourthLine = "Vi regulerer pga. overproduktion på nettet.";
      }            
    } 

    //console.log("##################" + firstLine);

    return (
      <div className="home-information">
        <span>{firstLine}</span>
        <br />
        <span>{secondLine}</span>
        <br />
        <br />
        <span className="red-text">{thirdLine !== "" ? (<img resizeMode='contain' src={pauseIcon} alt="Howdy"/>) : ('')} {thirdLine}</span>
        <br />
        <span className="red-text">{fourthLine}</span>        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/Information.js